export { default as NTree, treeProps } from './src/Tree';
